// ====================================================
// More Templates: https://www.ebenmonney.com/templates
// Email: support@ebenmonney.com
// ====================================================

import { Directive, Renderer2, ElementRef, OnInit } from '@angular/core';


@Directive({
    selector: '[autofocus]',
    standalone: false
})
export class AutofocusDirective implements OnInit {
    constructor(public renderer: Renderer2, public elementRef: ElementRef) { }

    ngOnInit() {
        this.setFocus();
    }
    setFocus() {
        if (this.elementRef.nativeElement.offsetParent == null) {
            this.setFocus();
        } else {
            setTimeout(() => {
                var elem = this.renderer.selectRootElement(this.elementRef.nativeElement);
                this.renderer.listen(elem, "focus", () => { });
            });
        }
    }
}
